import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Scorecard = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Scorecard' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M9,18 L9,12 M12,18 L12,13 M15,18 L15,10 M17,3 L21,3 L21,23 L3,23 L3,3 L7,3 M7,1 L17,1 L17,5 L7,5 L7,1 Z' />
  </StyledIcon>
);
